<template>
  <vue-aos animation-class="slide-in animated" :threshold="0.3">
    <section class="reviews pt-4 pb-2" id="reviews">
      <div class="text-center">
        <h1 class="underline text-white">Customer Reviews</h1>
      </div>
      <div class="example-3d p-0">
        <swiper class="swiper " :options="swiperOption">
          <swiper-slide v-for="(review, index) in reviews" :key="index">
            <div class="d-flex flex-column px-4 w-100">
              <p class="letter-spacing-sm reviews__review__body">
                " {{ review.body }} "
              </p>
              <div>
                <img
                  v-lazy="review.img"
                  height="50"
                  width="50"
                  class="rounded-circle"
                />
              </div>
              <p class="mb-1 mt-2 letter-spacing-sm">{{ review.name }}</p>
              <p class="mb-1 mt-1 letter-spacing-sm">{{ review.country }}</p>
              <div class="text-center">
                <b-form-rating
                  class="bg-transparent p-0 w-40"
                  size="sm"
                  variant="warning"
                  id="rating-inline"
                  no-border
                  inline
                  :value="review.rating"
                  readonly
                ></b-form-rating>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div
            class="swiper-button-prev text-portfolio1 position-absolute"
            slot="button-prev"
          ></div>
          <div
            class="swiper-button-next text-portfolio1 position-absolute"
            slot="button-next"
          ></div>
        </swiper>
      </div>
    </section>
  </vue-aos>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "swiper-example-3d-cube",
  title: "3D Cube effect",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      reviews: [
        {
          body:
            "Outstanding service. Extremely fast and explained every step of the way. Excellent communication and I will definitely do more business with RobustOffice in the future.",
          name: "Tom",
          country: "USA",
          img: require("../../assets/images/home/reviews/1.png"),
          rating: 5,
        },
        {
          body:
            "Excellent and skilled developers. Easy communication, always willing to help and they do not complete the project until it meets completely your expectations.",
          name: "javitorrz",
          country: "SPAIN",
          img: require("../../assets/images/home/reviews/1.png"),
          rating: 5,
        },
        {
          body:
            "We're very happy that we found Robust Office. We can really recommend working with them!.",
          name: "Webhikers Software",
          country: "AUSTRIA",
          img: require("../../assets/images/home/reviews/1.png"),
          rating: 5,
        },
      ],
      swiperOption: {
        effect: "cube",
        loop: true,
        grabCursor: true,
        cubeEffect: {
          shadow: true,
          slideShadows: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>
